import { createSyncRunner } from '../platform/sync-runner';
import { wdb, WORDLE_TABLE_MAP } from './db';

/**
 * The wordle sync loop — the platform runner bound to this module's own Dexie
 * database, outbox and endpoint. Started alongside (and independently of) the
 * other modules' loops when the app is signed in.
 */
export const wordleSync = createSyncRunner({
  endpoint: '/api/v1/wordle/sync',
  db: wdb,
  outbox: wdb.outbox,
  meta: wdb.meta,
  rejections: wdb.rejections,
  tables: WORDLE_TABLE_MAP,
  sinceKey: 'wordle_since',
  lastOkKey: 'wordle_last_ok',
});

export const startWordleSync = () => wordleSync.startLoop();
